import { SendTraceEvents, TraceEvent } from './trace-event'

export class BeaconEventSender implements SendTraceEvents {
  constructor(private tracingUrl: string) {}

  public send(event: TraceEvent): void {
    if (navigator.sendBeacon) {
      navigator.sendBeacon(this.tracingUrl, JSON.stringify(event))
    }
    // TODO: fallback to xhr?
  }
}
